"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ListingForm_1 = require("./ListingForm");
var HostAppView_1 = require("@twii/core-ui-fabric/lib/component/HostAppView");
var ListingModel_1 = require("../model/ListingModel");
var ListingMenuHelper_1 = require("./ListingMenuHelper");
var ListingNavHelper_1 = require("./ListingNavHelper");
var ListingAddApp = /** @class */ (function (_super) {
    __extends(ListingAddApp, _super);
    function ListingAddApp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._onSave = function (listing) {
            listing.save().then(function () {
                _this.host.load({ path: "/ozone/listings/" + listing.id });
            }).catch(function () {
                // we don't do anything here - the error should be reported on the model
            });
        };
        _this._onSaveImmediate = function () {
            _this._onSave(_this._listing);
        };
        _this._onSubmitForApproval = function (listing) {
            listing.submitForApproval().then(function () {
                _this.host.load({ path: "/ozone/listings/" + listing.id });
            }).catch(function () {
                // we don't do anything here - the error should be reported on the model
            });
        };
        _this._onCancel = function () {
            ListingNavHelper_1.popAndLoad(_this.host, { path: "/ozone/store" });
        };
        return _this;
    }
    Object.defineProperty(ListingAddApp.prototype, "host", {
        get: function () {
            return this.props.match.host;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ListingAddApp.prototype, "userProfile", {
        get: function () {
            return this.props.match.userProfile;
        },
        enumerable: true,
        configurable: true
    });
    ListingAddApp.prototype.componentWillMount = function () {
        this._listing = new ListingModel_1.ListingModel();
        this.host.setTitle("Add Listing");
    };
    ListingAddApp.prototype.render = function () {
        var items = [];
        var backItem = ListingMenuHelper_1.createBackItem(this.host);
        if (backItem) {
            items.push(backItem);
        }
        items.push({
            key: "cancel",
            name: "Cancel",
            iconProps: {
                iconName: "Cancel"
            },
            onClick: this._onCancel
        }, {
            key: "save",
            name: "Save",
            iconProps: {
                iconName: "Save"
            },
            disabled: this._listing.saveSync.syncing,
            onClick: this._onSaveImmediate
        });
        return (React.createElement(HostAppView_1.HostAppView, { host: this.host, commandBarProps: { items: items } },
            React.createElement(ListingForm_1.ListingForm, { listing: this._listing, onSave: this._onSave, onSubmitForApproval: this._onSubmitForApproval, onCancel: this._onCancel })));
    };
    return ListingAddApp;
}(React.Component));
exports.ListingAddApp = ListingAddApp;
exports.default = ListingAddApp;
